import Vue from "vue";
import Vuex from "vuex";
//import VuexPersist from 'vuex-persist'

Vue.use(Vuex);

/*
const vuexPersist = new VuexPersist({
    key: 'logger-software-V1',
    storage: window.localStorage
})
*/

const store = new Vuex.Store({
    plugins: [
        /*vuexPersist.plugin*/
    ],
    state: {
        token: null,
        user: null,
        selectedTimestamp: 0,
        log: null,
        device: null,
        devices: [],
        logVersion: 0,
        markerPosition: false,
        chartIndex: [0, 1],
        chartGroup: [null, null],
        blobs: {},
        mapToken: null,
        networkAvailable: true,

        // variables for controlling service worker updates.
        serviceWorkerUpdateAvailable: false,
        workBoxRegistration: null
    },
    mutations: {
        setUser(state, user) {
            Vue.set(state, "user", user);
        },
        setLog(state, log) {
            Vue.set(state, "log", log);
            // when the log is changed, default to the graphs to the first 2 available groups

            state.chartIndex.forEach((chartIndex, controlIndex) => {
                // availableGroups is sorted in order of index attribute when the chart is decoded.
                if (log) {
                    const index =
                        log.availableGroups.length > controlIndex
                            ? log.availableGroups[controlIndex].index
                            : 0;
                    Vue.set(state.chartIndex, controlIndex, index);
                } else {
                    // sometimes we null out the log to prevent the browser from wasting cycles
                    // loading an old log.  In that case, just set the chart indices to their
                    // related control index.
                    Vue.set(state.chartIndex, controlIndex, controlIndex);
                }
            });
        },
        setDevice(state, device) {
            Vue.set(state, "device", device);
        },
        setDevices(state, devices) {
            Vue.set(state, "devices", devices);
        },
        clearLogId(state) {
            // sets the log id to zero so that it is not associated with any
            // real id in the system.
            Vue.set(state.log, "id", 0);
        },
        incrementLogVersion(state) {
            state.logVersion += 1;
        },
        setSelectedTimestamp(state, timestamp) {
            Vue.set(state, "selectedTimestamp", timestamp);
        },
        setMarkerPosition(state, markerPos) {
            state.markerPosition = markerPos;
        },
        setChartIndex(state, payload) {
            Vue.set(state.chartIndex, payload.control, payload.group);
        },
        setChartGroup(state, payload) {
            Vue.set(state.chartGroup, payload.control, payload.group);
        },
        setBlob(state, payload) {
            if (state.blobs[payload.token] === undefined) {
                Vue.set(state.blobs, payload.token, []);
            }

            Vue.set(
                state.blobs[payload.token],
                payload.fileNumber,
                payload.data
            );
        },
        setMapToken(state, payload) {
            state.mapToken = payload;
        },
        setOffline(state) {
            state.networkAvailable = false;
        },
        setOnline(state) {
            state.networkAvailable = true;
        },
        serviceWorkerUpdateIsAvailable(state) {
            state.serviceWorkerUpdateAvailable = true;
        },
        serviceWorkerUpdateReset(state) {
            state.serviceWorkerUpdateAvailable = false;
        },
        setWorkBoxRegistration(state, payload) {
            state.workBoxRegistration = payload;
        }
    },
    actions: {},
    getters: {}
});

export default store;
